//@@added because static Docs menu is being manipulated with all the catalog items
// and hence doesn't serve main purpose of fallback so adding this non mainpulated static sidemenu so it is present al time
// also this will be fallback while active items are being filtered for initial load in API page
const defaultStaticFallbackSidemenu = [
  // {
  //   id: 0,
  //   name: 'Docs Home',
  //   description: 'API Docs Home',
  //   type: 'content',
  //   link: '/apis/docs-home',
  //   subMenu: null,
  // },
  // {
  //   id: 1,
  //   name: 'Integration Checklist',
  //   description: 'Integration Checklist',
  //   type: 'content',
  //   link: '/apis/integration-checklist',
  //   subMenu: null,
  // },
  {
    id: 2,
    name: 'Authorization',
    description: 'Authorization',
    type: 'content',
    link: '/apis/authorization',
    apiname: 'authorization-api',
    repourl: 'pages/authorization-api',
    subMenu: null,
  },
  {
    id: 3,
    name: 'JSON Web Signature (JWS)',
    description: 'JSON Web Signature (JWS)',
    type: 'content',
    link: '/apis/json-web-signature',
    repourl: 'pages/json-web-signature',
    subMenu: null,
  },
];

export { defaultStaticFallbackSidemenu };
